import React from 'react'

function TextInput({label, placeholder, error, dataId, value, onChange}) {
  return(
    <div className="columns is-gapless">
        <div className="column is-4">
          <div className="field-label">
            <label className="label">{ label }</label>
          </div>
        </div>
        <div className="column is-7">
            <div className="control">
              <input
                type="text"
                className={ error ? "input is-danger" : "input" }
                placeholder={ placeholder }
                data-id={ dataId }
                value={ value }
                onChange={ onChange }
              />
            </div>
            {error ? <p className="help is-danger">Пожалуйста, заполните это поле</p> : null}
        </div>
      </div>
  )
}

TextInput.propTypes = {
  label: React.PropTypes.string.isRequired,
  placeholder: React.PropTypes.string.isRequired,
  error: React.PropTypes.bool.isRequired,
  dataId: React.PropTypes.string.isRequired,
  value: React.PropTypes.string.isRequired,
  onChange: React.PropTypes.func.isRequired
};

TextInput.defaultProps = {
  error: false,
  value: ''
};

export default TextInput


// WEBPACK FOOTER //
// ./src/components/inputs/TextInput.js